export default {
  showLoaderHandler: undefined as ((arg: boolean) => void) | undefined,

  showLoader (arg: boolean) {
    this.showLoaderHandler && this.showLoaderHandler(arg)
  }
}
